import { DestroyRef, inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services';
import { map, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Pipe({
	name: 'ordinal',
})
export class OrdinalPipe implements PipeTransform {
	private readonly languageService = inject(LanguageService);
	private readonly destroyRef = inject(DestroyRef);
	transform(value: number): Observable<string> {
		return this.languageService.selectedLanguage$.pipe(
			takeUntilDestroyed(this.destroyRef),
			map((lang) => {
				if (isNaN(value)) {
					return '';
				}
				if (lang === 'sr') {
					return value + '.';
				}
				const suffixes = ['th', 'st', 'nd', 'rd'];
				const v = value % 100;
				return value + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
			})
		);
	}
}
